import { BROWSE_REQUEST_BRANCH_CONTENT, BROWSE_FORWARD_BRANCH_CONTENT } from './browse-actions'

function browseByState(state = { }, action) {

    console.log('browseByState', action);
    switch (action.type) {
        case BROWSE_FORWARD_BRANCH_CONTENT:
            let { branch, query } = action.result;
            return { ...state, branchContentLoading: false, branch, query }
        case BROWSE_REQUEST_BRANCH_CONTENT:
            return { ...state, branchContentLoading: true, branch, query}
        default:
            return state
    }
}

export default browseByState
